import { useState, useEffect } from "react";
import { Oval } from "react-loader-spinner";
import "./LoginPage.css";
import {
  IoMailOutline,
  IoLockClosedOutline,
  IoEyeOutline,
  IoEyeOffOutline,
  IoArrowForward,
} from "react-icons/io5";
import { SignUpPage } from "../index";
import logoImg from "../../images/JainamLogo.png";
import { useLoginContext } from "../../context/Login_context";
import Notification from "../../utils/Notification";

const LoginPage = () => {
  const { LoginUser, login_loading } = useLoginContext();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsLoaded(true), 100);
  }, []);

  const email_validation =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

  const handleLogin = async (e) => {
    e.preventDefault();

    if (email === "") {
      Notification("warning", "Enter Email ID..!!!");
    } else if (email_validation.test(email) === false) {
      Notification("warning", "Enter Valid Email ID..!!!");
    } else if (password === "") {
      Notification("warning", "Enter Password!!!");
    } else {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("password", password);
      await LoginUser(formData);
    }
  };

  if (showSignUp) {
    return <SignUpPage goToLogin={() => setShowSignUp(false)} />;
  }

  return (
    <div className="login-container">
      <div className="paper-decor decor-1"></div>
      <div className="paper-decor decor-2"></div>
      <div className="paper-decor decor-3"></div>

      <div className={`login-card ${isLoaded ? "slide-up" : ""}`}>
        <div className="login-header">
          <div className="logo-wrapper">
            <div className="logo-gradient">
              <img src={logoImg} alt="Logo" className="logo-img" />
            </div>
          </div>
          <h1 className="welcome-text">Welcome Back!</h1>
          <p className="subtitle">Login to continue</p>
        </div>

        <form onSubmit={handleLogin}>
          {/* Email Address */}
          <div className="login-input-wrapper">
            <label className="label">Email Address</label>
            <div className="input-container">
              <IoMailOutline className="input-icon" size={20} />
              <input
                type="email"
                className="input-field"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          {/* Password */}
          <div className="input-wrapper">
            <label className="label">Password</label>
            <div className="input-container">
              <IoLockClosedOutline className="input-icon" size={20} />
              <input
                type={showPassword ? "text" : "password"}
                className="input-field"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div
                className="eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <IoEyeOutline size={22} />
                ) : (
                  <IoEyeOffOutline size={22} />
                )}
              </div>
            </div>
          </div>
          <button type="submit" className="login-btn" disabled={login_loading}>
            {login_loading ? (
              <Oval
                height={40}
                width={40}
                color="#F5F5F5"
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#F5F5F5"
                strokeWidth={2}
                strokeWidthSecondary={2}
              />
            ) : (
              "Login"
            )}
            {!login_loading && <IoArrowForward size={20} />}
          </button>

          <div className="divider">
            <div className="line"></div>
            <div className="divider-text">OR</div>
            <div className="line"></div>
          </div>

          <div className="signup-footer">
            <span>Don't have an account? </span>
            <span className="signup-link" onClick={() => setShowSignUp(true)}>
              Sign Up
            </span>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
